import React, { useState, useEffect } from 'react'
import add from '../../../../assets/images/add.png'
import { useHistory } from 'react-router-dom';
import $ from 'jquery';
import Api from "../../../../apis/apis";
import Notifications from "../../../../notifications/notifications";



function State() {

    let history = useHistory();

    let [states, setState] = useState(null);

    useEffect(async () => {

        let res=await Api.allStates();
        if (res.status == '200')
        {
            setState(res.data);
        }

        //initialize datatable
        $(document).ready(function () {
            setTimeout(function () {
                $('#example').DataTable();
            }, 500);
        });
    }, [])


    async function Delete(id) {
        let data = {
            id: id
        }

        let res = await Api.deleteState(data);
        console.log(res);

        if (res.status == '200') {
            await Notifications.successMsg(res.message);
            await refreshRecord();
        }
    }

    async function refreshRecord() {
        let res=await Api.allStates();
        if (res.status == '200')
        {
            setState(res.data);
        }
    }




    return (
        <>
            <div className='driver-head'>
                <h3 className='dashboard-head-title'>States</h3>
                <div>
                    <div className='nav-buttons'>
                        <button onClick={() => history.push('/add-state')} style={{ background: '#FF7B00', marginRight: '15px' }}><img src={add} alt="" />  Add State</button>
                    </div>
                </div>
            </div>
            <div className='dashboard-table-wrapper_ p-3' >

                <table id="example" className="table table-hover table-bordered" style={{ overFlow: "auto" }}>
                    <thead>
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Delete</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        states?.map((itm,i)=>(
                            <tr>
                                <td>{itm.id}</td>
                                <td>{itm.name}</td>
                                <td><i onClick={async ()=>{await Delete(itm.id)}} className={'fas fa-trash'} style={{cursor: "pointer",color: "red"}}></i></td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default State